import { CopyText, HeaderTitle } from '@/components';
import { Table } from 'antd';
import React from 'react';

function SystemLink() {
  const columns = [
    {
      width: 100,
      title: '位置',
      align: 'center',
      dataIndex: 'title',
    },
    {
      width: 150,
      title: '链接（点击可复制）',
      align: 'center',
      dataIndex: 'link',
      render: e => {
        const url = `/${e}`;
        return <CopyText text={url} link />;
      },
    },
    {
      width: 100,
      title: '备注',
      align: 'center',
      dataIndex: 'extra',
      render: e => e || '-',
    },
  ];

  const data = [
    {
      title: '竞拍和邀约商品详情',
      link: 'auctiondetail?id=xxx',
      extra: '竞拍商品详情的id属性',
    },
    {
      title: '认购商品详情',
      link: 'subscribedetail?id=xxx',
      extra: '认购商品详情的id属性',
    },
    {
      title: '兑换商品详情',
      link: 'storedetail?id=xxx',
      extra: '认购商品详情的id属性',
    },
    // {
    //   title: '竞拍商品列表',
    //   link: 'productlist?id=xx',
    //   extra: '商品二级分类的id属性',
    // },
    // {
    //   title: '认购商品列表',
    //   link: 'subscribelist',
    // },
    {
      title: '店铺中心',
      link: 'merchant?id=xxx',
      extra: '店铺的id属性',
    },
    {
      title: '竞拍专场',
      link: 'auction',
      extra: '竞拍转拍列表',
    },
    {
      title: '认购专场',
      link: 'subscription',
      extra: '认购专场列表',
    },
    {
      title: '兑换商城',
      link: 'store',
      extra: '兑换商城列表',
    },
    {
      title: '邀约拍',
      link: 'invite',
      extra: '邀约拍列表',
    },
    {
      title: '拍间',
      link: 'auctionHouse',
      extra: '拍间列表',
    },
  ];

  return (
    <>
      <HeaderTitle />
      <Table
        bordered
        size="small"
        columns={columns}
        dataSource={data}
        pagination={false}
        style={{ width: '1000px' }}
        rowKey={({ link }) => link}
      />
    </>
  );
}

export default SystemLink;
